import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite/no-important';
import {
  TRANSPARENT,
  WHITE,
  LOCHMARA,
  DOVE_GRAY,
  FONTS,
  CENTER,
} from '../styles';
import Localisation from './Text';
import Icon from './Icon';

export const TYPES = {
  DEFAULT: 'DEFAULT',
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  TRANSPARENT: 'TRANSPARENT',
};

const s = StyleSheet.create({
  default: {
    appearance: 'none',
    backgroundColor: TRANSPARENT,
    borderWidth: 0,
    color: WHITE,
    padding: '9px 15px',
    outline: 0,
    cursor: 'pointer',
    fontSize: '14px',
    borderRadius: 2,
    textDecoration: 'none',
    ':hover': {
      filter: 'brightness(110%)',
    },
    ':disabled': {
      opacity: 0.5,
    },
  },
  buttonWithIcon: {
    display: 'flex',
    alignItems: CENTER,
  },
  [TYPES.PRIMARY]: {
    borderColor: LOCHMARA,
    borderWidth: 1,
    borderStyle: 'solid',
    backgroundColor: LOCHMARA,
  },
  [TYPES.SECONDARY]: {
    borderColor: DOVE_GRAY,
    borderWidth: 1,
    borderStyle: 'solid',
    color: DOVE_GRAY,
    transition: 'color .125s, background-color .125s',

    ':hover': {
      color: WHITE,
      backgroundColor: DOVE_GRAY,
    },
  },
  [TYPES.TRANSPARENT]: {
    paddingLeft: 0,
    paddingRight: 0,
    color: DOVE_GRAY,
    ...FONTS.BOLD,
    ':hover': {
      filter: 'brightness(80%)',
    },
  },
  icon: {
    width: 20,
    height: 20,
    flexShrink: 0,
  },
});

const DEFAULT_PORPS = {
  button: {
    type: 'button',
  },
};

const Button = ({
  __className,
  __iconClassName,
  __type,
  iconName,
  component,
  transformer,
  ...props
}) => (
  <Localisation
    component={component}
    {...DEFAULT_PORPS[component]}
    {...props}
    transformer={(txt = '') => (
      <>
        {!!iconName && (
          <Icon name={iconName} __className={[s.icon, __iconClassName]} />
        )}
        {transformer(
          `${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`
        )}
      </>
    )}
    className={css(
      s.default,
      s[__type],
      !!iconName && s.buttonWithIcon,
      __className
    )}
  />
);

Button.defaultProps = {
  __type: TYPES.PRIMARY,
  component: 'button',
  transformer: (txt) => txt,
};

Button.propTypes = {
  __className: PropTypes.any,
  __iconClassName: PropTypes.any,
  __type: PropTypes.oneOf(Object.values(TYPES)),
  disabled: PropTypes.bool,
  iconName: PropTypes.string,
  transformer: PropTypes.func,
  component: PropTypes.any,
};

export default Button;
